import {BACKEND_URL, BACKEND_V2_URL} from './applicationContext';
import PortalApiService from './services/PortalApiService';
import {PortalV2ApiService} from './services/PortalV2ApiService';
import {FormValidationService} from './services/FormValidationService';

export const portalApiService: PortalApiService = new PortalApiService(BACKEND_URL);
export const portalV2ApiService: PortalV2ApiService = new PortalV2ApiService(BACKEND_V2_URL);
export const formValidationService: FormValidationService = new FormValidationService();
